<template>
  <div>
    <div style="margin-top: -24px; margin-left: 15px">
      <el-input
        size="small"
        style="width: 400px"
        :placeholder="placeholder"
        @keyup.enter="handleSearchByText"
        v-model="searchText"
      >
        <template #append>
          <el-button @click="handleSearchByText"
            ><i class="iconfont icon-sousuo"></i><span>查询</span></el-button
          >
        </template>
      </el-input>
    </div>

    <div v-loading="loading" class="table-wrapper">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane name="dependencies_assets">
          <template #label>
            <span style="font-size: 12px">引用资源</span>
          </template>
          <el-table
            size="default"
            :data="optionData.dependencies_assets.list"
            height="calc(100vh - 310px)"
            @sort-change="sortChange"
            border
          >
            <el-table-column width="66">
              <template #default="scope">
                <el-button
                  @click="handleRowClick(scope.row)"
                  link
                  type="primary"
                  size="small"
                  style="padding: 0"
                >
                  <i class="iconfont icon-level-down"></i>
                  查看
                </el-button>
              </template>
            </el-table-column>
            <el-table-column prop="asset_path" label="文件路径">
            </el-table-column>
            <el-table-column prop="bundle_name" label="所在AB包" width="120">
            </el-table-column>
            <el-table-column
              prop="file_size"
              label="文件大小"
              sortable="custom"
              width="120"
            >
              <template #default="scope">
                {{ humanSizePackage(scope.row.file_size) }}
              </template>
            </el-table-column>
            <el-table-column
              prop="inverse_dependencies_assets"
              label="被引用数"
              sortable="custom"
              width="120"
            >
            </el-table-column>
            <el-table-column
              prop="dependencies_assets"
              label="引用数"
              sortable="custom"
              width="120"
            >
            </el-table-column>
            <el-table-column
              prop="dependencies_bundles"
              label="总依赖AB包"
              sortable="custom"
              width="130"
            >
            </el-table-column>
            <el-table-column
              prop="dependencies_bundles"
              label="直接依赖AB"
              sortable="custom"
              width="130"
            >
            </el-table-column>
          </el-table>
          <div class="pagination-wrapper">
            <el-pagination
              background
              :page-size="optionData.dependencies_assets.count"
              :current-page="optionData.dependencies_assets.cursor"
              :total="optionData.dependencies_assets.total"
              @current-change="handlePagechange"
            >
            </el-pagination>
          </div>
        </el-tab-pane>
        <el-tab-pane name="dependencies_bundles">
          <template #label>
            <span style="font-size: 12px">总依赖AB包</span>
          </template>
          <el-table
            size="default"
            @sort-change="sortChange"
            :data="optionData.dependencies_bundles.list"
            height="calc(100vh - 310px)"
            border
          >
            <el-table-column width="66">
              <template #default="scope">
                <el-button
                  @click="handleRowClick(scope.row)"
                  link
                  type="primary"
                  size="small"
                  style="padding: 0"
                >
                  <i class="iconfont icon-level-down"></i>
                  查看
                </el-button>
              </template>
            </el-table-column>
            <el-table-column prop="bundle_name" label="AB包名">
            </el-table-column>
            <el-table-column
              prop="bundle_size"
              label="文件大小"
              sortable="custom"
              width="120"
            >
              <template #default="scope">
                {{ humanSizePackage(scope.row.bundle_size) }}
              </template>
            </el-table-column>
            <el-table-column
              prop="contain_assets"
              label="包含资源数"
              sortable="custom"
              width="120"
            >
            </el-table-column>
            <el-table-column
              prop="all_dependencies_bundles"
              label="总依赖AB包"
              sortable="custom"
              width="130"
            >
            </el-table-column>
            <el-table-column
              prop="direct_dependencies_bundles"
              label="直接依赖的AB包"
              sortable="custom"
              width="150"
            >
            </el-table-column>
          </el-table>
          <div class="pagination-wrapper">
            <el-pagination
              background
              :page-size="optionData.dependencies_bundles.count"
              :current-page="optionData.dependencies_bundles.cursor"
              :total="optionData.dependencies_bundles.total"
              @current-change="handlePagechange"
            >
            </el-pagination>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script setup>
import {
  defineProps,
  defineEmits,
  onMounted,
  reactive,
  ref,
  computed,
} from "vue";
import { humanSizePackage } from "@/Utils/UtilTools";
import { apiPackageParseDependency } from "@/Api/AppApi";

const props = defineProps(["param"]);
const emit = defineEmits(["selectRow"]);

const activeName = ref("dependencies_assets");
onMounted(() => {
  activeName.value = "dependencies_assets";
  loadData();
});

const placeholder = computed(() => {
  if (activeName.value.includes("assets")) {
    return "输入文件路径查询";
  } else if (activeName.value.includes("scenes")) {
    return "输入场景路径查询";
  } else {
    return "输入AB包名称查询";
  }
});

const optionData = reactive({
  dependencies_assets: {
    list: [],
    cursor: 1,
    count: 30,
    total: 0,
    searchcolumn: "asset_path",
    viewType: "assetsdetail",
  },
  dependencies_bundles: {
    list: [],
    cursor: 1,
    count: 30,
    total: 0,
    searchcolumn: "bundle_name",
    viewType: "boundledetail",
  },
});

const searchText = ref("");
async function handleSearchByText() {
  optionData.dependencies_assets.cursor = 1;
  optionData.dependencies_assets.count = 30;
  optionData.dependencies_bundles.cursor = 1;
  optionData.dependencies_bundles.count = 30;
  loadData(searchText.value);
}

let sortColumn = "";
let order = "";
function handleClick(evt) {
  activeName.value = evt.props.name;
  searchText.value = "";
  sortColumn = "";
  order = "";
  loadData();
}

function sortChange(evt) {
  sortColumn = evt.prop;
  order = evt.order;
  loadData(searchText.value);
}

function handleRowClick(row) {
  const data = {
    viewType: optionData[activeName.value].viewType,
    name: row[optionData[activeName.value].searchcolumn],
    type: row.type,
    deftab: "",
  };
  emit("selectRow", data);
}

function handlePagechange(p) {
  optionData[activeName.value].cursor = p;
  loadData(searchText.value);
}

const loading = ref(false);
async function loadData(search) {
  const name = activeName.value;
  const params = {
    name: props.param.name,
    version_id: props.param.versionid,
    type: "scene",
    tab: name,
    cursor: optionData[name].cursor,
    count: optionData[name].count,
  };

  if (search != undefined && search.length > 0) {
    params.search_key = optionData[name].searchcolumn;
    params.search_value = search;
  }
  if (sortColumn != undefined && sortColumn.length > 0) {
    params.sort_field = sortColumn;
  }
  if (order != undefined && order.length > 0) {
    params.order = order;
  }
  loading.value = true;
  const res = await apiPackageParseDependency(params);
  loading.value = false;
  if (res.code === 0) {
    optionData[name].list = res.data.list;
    optionData[name].total = res.data.total;
  }
}
</script>

<style lang="scss" scoped>
.table-wrapper {
  margin-top: 8px;
  width: 100%;
  background: #fff;
  padding: 15px 15px 0 15px;
  height: calc(100vh - 190px);

  :deep() {
    .el-table__inner-wrapper,
    .el-scrollbar__wrap {
      height: 100% !important;
    }

    .el-table__body-wrapper {
      height: calc(100% - 40px) !important;
    }
  }
}

.pagination-wrapper {
  display: flex;
  background-color: #ffffff;
  justify-content: center;
  padding: 5px 0;
  height: 46px;
}
</style>
